module.exports = __webpack_public_path__ + "static/media/desktopScreenshot05.d31ecb25.jpg";